"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends4 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _react = _interopRequireDefault(require("react"));

var _reactDom = require("react-dom");

var _q = _interopRequireDefault(require("q"));

var I18n = _interopRequireWildcard(require("I18n"));

var _Auth = _interopRequireDefault(require("./utils/Auth"));

var _hubspot = _interopRequireDefault(require("hubspot.PortalIdParser"));

var _env = require("./utils/env");

var _utils = require("./utils/utils");

var _Routes = _interopRequireDefault(require("ContentUtils/Routes"));

var _history = require("history");

var _reactRouter = require("react-router");

var _Routes2 = _interopRequireDefault(require("./Routes"));

var _historyAdapterV = _interopRequireDefault(require("react-rhumb/historyAdapterV3"));

var _RhumbProvider = _interopRequireDefault(require("react-rhumb/RhumbProvider"));

var _rhumbConfig = _interopRequireDefault(require("../rhumb-config.yaml"));

require("redux");

var _reactRedux = require("react-redux");

var _reactRouterRedux = require("react-router-redux");

var _reduxThunk = _interopRequireDefault(require("redux-thunk"));

var _NotificationMiddleware = _interopRequireDefault(require("ReduxMessenger/middleware/NotificationMiddleware"));

var _usageTrackerRedux = require("usage-tracker-redux");

var _actionHandlers = _interopRequireDefault(require("./lib/usage/actionHandlers"));

var _tracker = require("./lib/usage/tracker");

var _install = _interopRequireDefault(require("./middlewares/install"));

var _reducers = _interopRequireDefault(require("./reducers"));

var _configureStore2 = _interopRequireDefault(require("./utils/configureStore"));

var _en = _interopRequireDefault(require("i2l?query=sporks!../lang/en.lyaml"));

var _registerAllData = _interopRequireDefault(require("I18n/init/register/lazy/registerAllData"));

require("I18n/init/data/currency");

// Configure the router
// Configure the redux store
var Application =
/*#__PURE__*/
function () {
  function Application(_ref) {
    var i18nProvider = _ref.i18nProvider,
        tracker = _ref.tracker;
    (0, _classCallCheck2.default)(this, Application);
    (0, _tracker.setTracker)(tracker);
    this.i18nProvider = i18nProvider;
  }

  (0, _createClass2.default)(Application, [{
    key: "start",
    value: function start() {
      var _this = this;

      var withAuth = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      if ((0, _env.debug)()) {
        window.AppInstance = this;
      }

      var langAvailable = _q.default.Promise.all([this.i18nProvider.register(_en.default), (0, _registerAllData.default)(this.i18nProvider)]);

      var promises = [langAvailable];

      if (withAuth) {
        _hubspot.default.get();

        promises.push(_Auth.default.init().then(function (_ref2) {
          var user = _ref2.user,
              portal = _ref2.portal;

          _this.i18nProvider.setLocale({
            locale: user.locale,
            langEnabled: user.lang_enabled,
            timezone: portal.timezone
          });

          return langAvailable;
        }));
      }

      return _q.default.Promise.all(promises).done(function () {
        _this.setSentryParams();

        _this.startReduxAndRouter(withAuth);

        _this.translatePageTitle();
      });
    }
  }, {
    key: "getGatesMap",
    value: function getGatesMap(gates) {
      return gates.reduce(function (acc, gate) {
        return (0, _extends4.default)({}, acc, (0, _defineProperty2.default)({}, gate, true));
      }, {});
    }
  }, {
    key: "getScopesMap",
    value: function getScopesMap(user) {
      return user.scopes.reduce(function (acc, scope) {
        return (0, _extends4.default)({}, acc, (0, _defineProperty2.default)({}, scope, true));
      }, {});
    }
  }, {
    key: "setSentryParams",
    value: function setSentryParams() {
      I18n.sendSentryOnMissingTranslations = true;
      I18n.sendSentryOnMissingValues = true;
    }
  }, {
    key: "translatePageTitle",
    value: function translatePageTitle() {
      document.title = I18n.text('htmlTitle');
    }
  }, {
    key: "getUserGatesPortalScopesData",
    value: function getUserGatesPortalScopesData() {
      var _auth$get = _Auth.default.get(),
          user = _auth$get.user,
          gates = _auth$get.gates,
          portal = _auth$get.portal;

      return {
        user: user,
        allGates: gates,
        gates: this.getGatesMap(gates),
        portal: portal,
        scopes: this.getScopesMap(user)
      };
    }
  }, {
    key: "configureStore",
    value: function configureStore(routerHistory, initialState) {
      var usageTracker = (0, _tracker.getTracker)();
      var middleware = [(0, _reactRouterRedux.routerMiddleware)(routerHistory), _reduxThunk.default, _NotificationMiddleware.default, (0, _usageTrackerRedux.usageTrackerMiddleware)(usageTracker, _actionHandlers.default)].concat((0, _toConsumableArray2.default)(_install.default));
      return (0, _configureStore2.default)(_reducers.default, initialState, middleware);
    }
  }, {
    key: "startReduxAndRouter",
    value: function startReduxAndRouter(withAuth) {
      var userGatesPortalScopesData = {
        user: {},
        allGates: [],
        gates: {},
        portal: {},
        scopes: {}
      };
      var basename = '/';
      var isDeployed = (0, _env.deployed)('MarketplaceUI');

      if (withAuth) {
        userGatesPortalScopesData = this.getUserGatesPortalScopesData();
        basename = (0, _utils.getBaseUrlForCustomers)();
      } else if (!isDeployed) {
        basename = '/marketplace';
      }

      _Routes.default.init(userGatesPortalScopesData.allGates);

      var routerHistory = (0, _reactRouter.useRouterHistory)(_history.createHistory)({
        basename: basename
      });
      this.store = this.configureStore(routerHistory, {
        auth: userGatesPortalScopesData
      });
      var history = (0, _reactRouterRedux.syncHistoryWithStore)(routerHistory, this.store);
      (0, _reactDom.render)(_react.default.createElement(_reactRedux.Provider, {
        store: this.store
      }, _react.default.createElement(_RhumbProvider.default, {
        history: (0, _historyAdapterV.default)(history),
        config: _rhumbConfig.default
      }, _react.default.createElement(_reactRouter.Router, {
        history: history
      }, (0, _Routes2.default)(this.store)))), document.getElementsByClassName('page')[0]);
    }
  }]);
  return Application;
}();

exports.default = Application;
module.exports = exports.default;